import type { FamilyName } from "./family.enum"
import type { IsoDate } from "./isoDate"
import type { KeyFigure } from "./keyFigure"

export enum MarketShareDistributions {
  SALES = "sales",
  MARGIN = "margin",
  VOLUME = "volume",
}

export enum MarketShareKinds {
  SELECTED = "SELECTED",
  PRIORITY = "PRIORITY",
  OTHER = "OTHER",
}

type CommonMarketShare = {
  [MarketShareDistributions.SALES]?: KeyFigure | null
  [MarketShareDistributions.MARGIN]?: KeyFigure | null
  [MarketShareDistributions.VOLUME]?: KeyFigure | null
  periodStartDate?: IsoDate | null // date sent
  periodEndDate?: IsoDate | null // data date
}

export type MarketShareLaboratory = CommonMarketShare & {
  id?: number | null
  name: string
  kind: MarketShareKinds
}

export type MarketShareFamily<TName = FamilyName> = CommonMarketShare & {
  name: TName
  laboratories: MarketShareLaboratory[]
  tooltip?: string | null
}

export type MarketShareFamilies = {
  families: MarketShareFamily[]
}
